import isNil from 'lodash.isnil';
import { getBasicComprehensionValidationMessageConstants } from '../../constants/shared/BasicComprehensionValidationConstants';
import { RESPONSE } from '../../constants/shared/WebEntryConstants';

const { CORRECT_RESPONSES, INCORRECT_RESPONSES } = RESPONSE;

export const isPositiveInteger = value => {
    return Number.isInteger(value) && value >= 0;
};

export const hasAllData = fields => !fields.some(field => isNil(field));

export const isAllDataEmpty = fields => fields.every(field => isNil(field));

export const validate = (fields, questionsCount, isPm, title) => {
    const {
        WRONG_SUM_OF_VALUES_ERROR,
        WRONG_TYPE_ERROR,
        BM_EMPTY_FIELD_ERROR,
        PM_EMPTY_FIELD_ERROR,
    } = getBasicComprehensionValidationMessageConstants(title);
    const validationResponse = { error: null, highlightedInputs: [] };
    const fieldValues = Object.values(fields);
    if (isAllDataEmpty(fieldValues)) {
        return validationResponse;
    }
    if (hasAllData(fieldValues)) {
        const sumOfResponses = fields[CORRECT_RESPONSES] + fields[INCORRECT_RESPONSES];
        if (sumOfResponses > questionsCount) {
            validationResponse.error = WRONG_SUM_OF_VALUES_ERROR;
            validationResponse.highlightedInputs = [CORRECT_RESPONSES, INCORRECT_RESPONSES];
        }
    }
    Object.keys(fields).forEach(name => {
        if (isNil(fields[name])) {
            validationResponse.error = isPm ? PM_EMPTY_FIELD_ERROR : BM_EMPTY_FIELD_ERROR;
            validationResponse.highlightedInputs.push(name);
        } else if (
            (name === CORRECT_RESPONSES || name === INCORRECT_RESPONSES) &&
            !isPositiveInteger(fields[name])
        ) {
            validationResponse.error = WRONG_TYPE_ERROR;
            validationResponse.highlightedInputs.push(name);
        }
    });
    return validationResponse;
};
